import { FC } from 'react';
import { Content } from '@prismicio/client';
import { SliceComponentProps, PrismicRichText } from '@prismicio/react';

export type StrategicMilestoneHighlightProps =
  SliceComponentProps<Content.StrategicMilestoneHighlightSlice>;

const StrategicMilestoneHighlight: FC<StrategicMilestoneHighlightProps> = ({
  slice,
}) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="py-12 md:py-[50px] px-4 md:px-8 lg:px-[100px]"
    >
      <div className="max-w-[1240px] mx-auto">
        <PrismicRichText
          field={slice.primary.heading}
          components={{
            heading1: ({ children }) => (
              <h1 className="text-2xl md:text-[36px] font-medium leading-[1.3] text-center text-[#041118]">
                {children}
              </h1>
            ),
            heading2: ({ children }) => (
              <h2 className="text-2xl md:text-[36px] font-medium leading-[1.3] text-center text-[#041118]">
                {children}
              </h2>
            ),
            heading3: ({ children }) => (
              <h3 className="text-2xl md:text-[36px] font-medium leading-[1.3] text-center text-[#041118]">
                {children}
              </h3>
            ),
          }}
        />
      </div>
    </section>
  );
};

export default StrategicMilestoneHighlight;
